import React from 'react';

export const ErrorFlagIcon = (props: JSX.IntrinsicElements['svg']) => {
    return (
        <svg
            width="140"
            height="140"
            fill="none"
            viewBox="0 0 140 140"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M2.917 137.083V2.917M2.917 113.75a127.101 127.101 0 0135-5.833c17.5 0 43.75 11.666 61.25 11.666a108.017 108.017 0 0034.119-7.256 5.841 5.841 0 003.797-5.472V25.9a5.837 5.837 0 00-2.434-4.74 5.842 5.842 0 00-5.272-.784 101.306 101.306 0 01-30.21 5.874c-17.5 0-43.75-11.667-61.25-11.667a127.132 127.132 0 00-35 5.834v93.333zM72.916 78.75v-35"
                stroke="currentColor"
            />
            <path
                d="M72.864 90.417a1.434 1.434 0 00-1.406 1.487 1.482 1.482 0 001.458 1.43v0a1.435 1.435 0 001.406-1.488 1.482 1.482 0 00-1.406-1.43M72.916 90.417h-.029"
                stroke="currentColor"
            />
        </svg>
    );
};
